import { useState, useEffect } from "react";
import { CONFIG } from "../../config";
import { NoItemCard } from "../general/misc/NoItemCard";
import { displayMetricString } from "../clothing/ClothingCard";
import { IoAdd } from "react-icons/io5";
import { useErrorHandler } from "react-error-boundary";
import { requestHandler } from "../../helpers/requests";
import { CircularProgress } from "@mui/material";

export const ClothingRowCard = ({ piece, displayField = "" }) => {
	const [wears, setWears] = useState(piece.wears);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	useErrorHandler(error);

	const addOneWear = () => {
		let id = setTimeout(() => {
			setLoading(true);
		}, 100);
		const formData = new FormData();
		formData.append("piece_id", piece.piece_id);
		requestHandler.addOneWear(formData).then((response) => {
			if (response.ok) {
				setWears(wears + 1);
			} else {
				setError(response);
			}
			clearTimeout(id);
			setLoading(false);
		});
	};

	return (
		<div className="p-1">
			<div className="flex select-none w-full h-full border border-gray-400 shadow-sm rounded-md p-2">
				<div className="flex items-center shrink-0">
					<img
						className={`w-24 h-24 object-contain`}
						src={`${CONFIG.IMAGE_URL}${piece.piece_image_name}`}
					></img>
				</div>

				<div className="flex flex-grow overflow-hidden px-2 items-center font-light text-sm ">
					<div className="flex flex-col w-full justify-start flex-shrink overflow-hidden">
						<span className="text-sm font-normal truncate">
							{piece.brand}
						</span>
						<span className="text-sm font-light truncate">
							{piece.piece_name}
						</span>
						<span className="text-sm font-light truncate">
							{`${wears} ${wears == 1 ? "wear" : "wears"}`}
						</span>
					</div>
				</div>
				<div className="flex h-full items-center justify-end font-light text-sm">
					<div
						onClick={loading ? () => null : addOneWear}
						className={`relative flex items-center justify-center w-8 h-8 border rounded-full  ${
							loading
								? "border-gray-400 text-gray-400"
								: "hover:bg-black hover:text-white cursor-pointer"
						}`}
					>
						<IoAdd size={20} />
						{loading && (
							<div className="absolute flex items-center justify-center w-full h-full">
								<CircularProgress
									size={20}
									sx={{ color: "black" }}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
